import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { PublishedEventsClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.EventoQuery],
});

export const headCells: HeadCell<PublishedEventsClient, keyof PublishedEventsClient>[] = [
  {
    id: 'id',
    label: 'Id',
  },
  {
    id: 'dataTimePublication',
    label: 'Data ora pubblicazione',
  },
  {
    id: 'typeEventCode',
    label: 'Tipo Evento',
  },
  {
    id: 'eventDescription',
    label: 'Descrizione Tipo Evento',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaPublishedEventsFilter = yup.object({
  id: yup.number(),
});
